export const POLICY_DESK_PAGES = [
  {
    id: "privacy",
    path: "/app/privacy",
    title: "Privacy policy",
    teaser: "Data, security & your choices",
  },
  {
    id: "terms",
    path: "/app/terms",
    title: "Terms of service",
    teaser: "Platform rules & settlements",
  },
  {
    id: "community",
    path: "/app/community",
    title: "Community guidelines",
    teaser: "Respect, fairness & enforcement",
  },
];

export const getSiblingPolicyPages = (currentId) =>
  POLICY_DESK_PAGES.filter((page) => page.id !== currentId);
